import { Permissions } from './permission-def';
import { Roles, RolesAdministrative } from './role-def';

export interface RoleRule {
  role: Roles;
  permissions: Permissions[];
  allowedRoles: Roles[];
  defaultPath?: string;
}
export const ROLE_RULES : Array<RoleRule> = [
  {
    role: 'admin',
    permissions:['canAdmin'],
    // this user can create users with this other roles:
    allowedRoles: RolesAdministrative,
  },
  {
    role:'client_editor',
    permissions:[
      'editProjects'
    ],
    allowedRoles:[],
  },
  {
    role:'client_viewer',
    permissions:[
    ],
    allowedRoles:[],
  },
  {
    role:'external',
    permissions:[
    ],
    allowedRoles:[],
  },
]
